import { useTranslation } from 'react-i18next';
import { NewsletterForm } from '../NewsletterForm/NewsletterForm';
import './style.less';

export const NewsletterSection = () => {
  const { t } = useTranslation();

  return (
    <section className="newsletter-section">
      <div className="container">
        <div className="newsletter-section__content">
          <h3 className="newsletter-section__title">{t('newsletter.footer.title')}</h3>
          <p className="newsletter-section__description">{t('newsletter.footer.description')}</p>
          <NewsletterForm variant="footer" />
        </div>
      </div>
    </section>
  );
};
